import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormInstance } from 'antd/es/form'
import FormalityStepButton from '../FormalityStepButton'

interface IProps {
  form: FormInstance
  onFinish: any
  loading?: boolean
}
const NextStepConfirm = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { form, onFinish, loading = false } = props

  return (
    <>
      <FormalityStepButton
        title={t('show.form.submit.confirm.next.title')}
        description={t('show.form.submit.confirm.next.label')}
        buttonDisabled={loading}
        buttonLabel={t('show.form.submit.confirm.next.label')}
        onConfirm={() => onFinish(form.getFieldsValue())}
      />
    </>
  )
}

export default NextStepConfirm
